exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-brain-gain-thesis-js": () => import("./../../../src/pages/brain-gain-thesis.js" /* webpackChunkName: "component---src-pages-brain-gain-thesis-js" */),
  "component---src-pages-cats-js": () => import("./../../../src/pages/cats.js" /* webpackChunkName: "component---src-pages-cats-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

